export default __webpack_public_path__ + "0907469e9480acad07b43068bcb1c871.png";